import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  EmailShareButton,
  FacebookIcon,
  XIcon,
  LinkedinIcon,
  WhatsappIcon,
  TelegramIcon,
  EmailIcon,
} from 'react-share'

const ShareButtons = ({ url, title, description }) => (
  <div className="flex flex-col xs:flex-row items-start xs:items-center xs:space-x-1">
    <div className="mb-1 xs:mb-0 xs:-mt-2">Compartir en</div>
    <div className="space-x-2 xs:space-x-1">
      <FacebookShareButton url={url} quote={description}>
        <FacebookIcon size={31} round={true} />
      </FacebookShareButton>
      <TwitterShareButton url={url} title={description}>
        <XIcon size={31} round={true} />
      </TwitterShareButton>
      <WhatsappShareButton url={url} title={description}>
        <WhatsappIcon size={31} round={true} />
      </WhatsappShareButton>
      <TelegramShareButton url={url} title={description}>
        <TelegramIcon size={31} round={true} />
      </TelegramShareButton>
      <LinkedinShareButton url={url} title={title} summary={description}>
        <LinkedinIcon size={31} round={true} />
      </LinkedinShareButton>
      <EmailShareButton url={url} subject={description} body={description}>
        <EmailIcon size={31} round={true} />
      </EmailShareButton>
    </div>
  </div>
)

export default ShareButtons
